// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".statistics_root__3pzTU {\n  background: #fafafa;\n  display: flex;\n  justify-content: center;\n  height: 100%;\n  width: 100%; }\n  .statistics_root__3pzTU .statistics_content__1zK53 {\n    width: calc(100% - 60px);\n    height: calc(100% - 60px);\n    min-height: 300px;\n    padding: 20px;\n    background: #fff;\n    border-radius: 15px;\n    overflow: auto;\n    box-shadow: 2px 1px 11px 3px rgba(181, 181, 181, 0.4);\n    margin-top: 10px; }\n  .statistics_root__3pzTU .statistics_head__3Nu9L {\n    margin-top: 0;\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 22px;\n    color: #333333;\n    -webkit-user-select: none;\n            user-select: none; }\n", ""]);
// Exports
exports.locals = {
	"root": "statistics_root__3pzTU",
	"content": "statistics_content__1zK53",
	"head": "statistics_head__3Nu9L"
};
module.exports = exports;
